<!-- Иконка публикации с тремя связанными точками. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="18" cy="5" r="3" :stroke="stroke" stroke-width="2" />
    <circle cx="6" cy="12" r="3" :stroke="stroke" stroke-width="2" />
    <circle cx="18" cy="19" r="3" :stroke="stroke" stroke-width="2" />
    <path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4" :stroke="stroke" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "ShareIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
